import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Authenticate, User} from '../models/user';
import {HttpClient} from '@angular/common/http';
import {catchError, map, mergeMap, tap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {TokenService} from './token.service';
import {AuthResources} from './auth-resources';
import {authErrorSelector} from './auth-error-selectors';
import {TokenStoreService} from './token-store.service';

@Injectable()
export class AuthService {

    constructor(private http: HttpClient, private tokenService: TokenService, private tokenStore: TokenStoreService) {
    }

    get resourceUrl(): string {
        return environment.rest_backend + AuthResources.customerResource;
    }

    logout() {
        this.tokenStore.token = '';
    }

    getUser(): Observable<User> {
        return this.http.get(this.resourceUrl)
            .pipe(
                map((response: any) => {
                    console.log(response);
                    return response as User;
                }),
                catchError(authErrorSelector)
            );
    }

    login({email, password}: Authenticate): Observable<User> {
        return this.tokenService.getToken({email, password})
            .pipe(
                tap(token => this.tokenStore.token = token),
                mergeMap(() => this.getUser()),
            );
    }
}
